export const ButtonSkinGuideLines = () => {
  return (
    <div className="flex flex-col gap-2 text-xs sm:text-sm">
      <div className="font-bold text-sm">Button Image Guidelines</div>
      <div>Please use the following guidelines for your button image:</div>
      <ul className="list-disc ml-4">
        <li>Layout: <b>Centered</b></li>
        <li>Recommended dimensions: <b>1080x1080 px</b></li>
        <li>File type: <b>PNG, JPG</b></li>
        <li>Max file size: <b>5MB</b></li>
      </ul>
    </div>
  );
};
